module.exports = __webpack_public_path__ + "static/media/YM70_6.28f4717c.jpg";